import { api } from 'utility';
import {
  getAllBusinessInfoUrl,
  getConfirmServiceCallApiKeyUrl,
  getRevokeApiKeyUrl,
  getGenerateApiKeyUrl,
  getApiKeyListUrl,
} from 'URLs';
export function getRequests(params) {
  return api.get(getApiKeyListUrl(), { params }).then((res) => res.data);
}
export function generateApiKeyApi(data, serviceId) {
  return api.get(getGenerateApiKeyUrl(serviceId), data).then((res) => res.data);
}
export function revokeApiKeyApi(params, requestId) {
  return api.delete(getRevokeApiKeyUrl(requestId), { params }).then((res) => res.data);
}
export function getBusinessList(obj) {
  const params = { offset: 0, size: 10, ...obj };
  return api.get(getAllBusinessInfoUrl(), { params }).then((res) => res.data);
}

export function confirmRequestApi(data) {
  return api.post(getConfirmServiceCallApiKeyUrl(), data).then((res) => res.data);
}

export default {
  getRequests,
  generateApiKeyApi,
  revokeApiKeyApi,
  getBusinessList,
  confirmRequestApi,
};
